export const isEventRate = ({ rate = null, isMonthly = false, isAirport = false, }) => {
    if (!rate || isMonthly || isAirport) {
        return {};
    }
    if (rate?.rateId) {
        return { event_rate: rate.rateId === 'event-rate' };
    }
    else if (rate?.fullRule) {
        return { event_rate: rate.fullRule === 'event-rate' };
    }
    else {
        return {};
    }
};
